import { render } from "./BonoConductorFormPage.vue?vue&type=template&id=b537b10c"
import script from "./BonoConductorFormPage.vue?vue&type=script&lang=js"
export * from "./BonoConductorFormPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__